import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

/**
 * Ziel der AuthGuard-Umleitung bei fehlender Berechtigung. Vorher existierte
 * die Route nicht — abgewiesene Benutzer landeten kommentarlos über den
 * **-Wildcard auf der Welcome-Seite.
 */
@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [RouterLink],
  template: `
    <div class="unauthorized-wrap">
      <h3>Keine Berechtigung</h3>
      <p>
        Ihr Benutzerkonto hat keine Berechtigung für diese Seite.
        Wenden Sie sich an das KIUT-Team, falls Sie Zugriff benötigen.
      </p>
      <a routerLink="/welcome" class="btn btn-sm btn-outline">Zur Startseite</a>
    </div>
  `,
  styles: [`
    .unauthorized-wrap {
      max-width: 32rem;
      margin: 4rem auto;
      padding: 0 1rem;
      text-align: center;
    }
    .unauthorized-wrap h3 { margin-bottom: 0.75rem; }
    .unauthorized-wrap p { margin-bottom: 1.25rem; }
  `],
})
export class UnauthorizedComponent {}
